export const InsightPlatformWikiLink = "https://o365exchange.visualstudio.com/O365%20Core/_wiki/wikis/O365%20Core.wiki/484025/Actionable-Insights-in-Jaws";

export const InsightPlatformDescriptions: Record<string, string> = {
    "ResourceUri": "In Substrate, name will be Ring|ComponentType|ComponentName. In Azure, it will be SubscriptionId|SubscriptionName|Region",
    "CostSaving": "Estimated monthly cost increase",
    "InsightStatus": "'New' refers to newly detected anomalies that are currently under investigation. 'Ongoing' anomalies are unexpected increases that have been confirmed with users",
};